import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@components';

class ReportsTable extends Component {
	shouldComponentUpdate = () => true;

	render() {
		const {
			data, header, tableColumn, onClickRow,
		} = this.props;

		return (
			<div className="margin-top-10">
				<If condition={header}>
					<div className="report-table-header margin-top-20 margin-bottom-1">
						<span className="color-dark font-regular report-table-header-title">
							{ header }
						</span>
					</div>
				</If>
				<Table
					rowKey={header === 'Invoice Summary' || header === 'Invoice Payment Summary' ? 'JobId' : 'Id'}
					className="compact-row header-dark bg-white overflow-y-auto"
					containerClassName="report-table"
					columns={tableColumn}
					data={data}
					onClickRow={onClickRow}
				/>
			</div>
		);
	}
}

ReportsTable.propTypes = {
	data        : PropTypes.array,
	header      : PropTypes.string,
	tableColumn : PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.array,
	]).isRequired,
	onClickRow : PropTypes.func,
};

ReportsTable.defaultProps = {
	data       : [],
	header     : '',
	onClickRow : () => {},
};

export default ReportsTable;
